export default __webpack_public_path__ + "static/media/ic_interaciones_medicamentosas_home_pro.942587e0.svg";